import DateRangePicker from "react-bootstrap-daterangepicker";
import SpyFilterCategory from "./category";
import { MORE_FILTERS } from "../constant";
import FilterGroup from "./group";
import SelectBox from "components/elements/selectBox";
import { formatterCreateAt } from "components/Function";
import moment from "moment";

const SpyFilter = ({
    filter,
    setFilter,
    filterShows = [],
    filterAdvancedShows = [],
    filterCategory = [],
    filterMoreCategory = [],
}) => {
    let more_filters = MORE_FILTERS;
    if (Boolean(Object.keys(filterMoreCategory).length)) {
        filterMoreCategory.dateRange = MORE_FILTERS.dateRange;
        filterMoreCategory.region = MORE_FILTERS.region;
        more_filters = filterMoreCategory;
    }

    const DrawFilter = (item) => {
        if (item.type === "group") {
            return (
                <FilterGroup
                    item={item}
                    key={item.value[0].value}
                    filter={filter}
                    setFilter={setFilter}
                    filterMoreCategory={filterMoreCategory}
                />
            );
        }
        if (item.type === "date_picker") {
            return (
                <div className="d-flex flex-column" key={item.value}>
                    <label className="form-label">{item.label}</label>
                    <div className="position-relative w-100">
                        <DateRangePicker
                            onCallback={(start, end) => {
                                let date_start = new Date(start);
                                date_start.setHours(0, 0, 0, 0);

                                let date_end = new Date(end);
                                date_end.setHours(0, 0, 0, 0);

                                setFilter((prev) => ({
                                    ...prev,
                                    start_time: Math.floor(date_start.getTime() / 1000),
                                    end_time: Math.floor(date_end.getTime() / 1000),
                                }));
                            }}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.start_time || "", "dmy"),
                                endDate: formatterCreateAt(filter.end_time || "", "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                                maxDate: new Date(),
                            }}
                        >
                            <input
                                type="text"
                                className="form-control al-form-control-daterangepicker"
                                value={`${
                                    moment(filter.start_time ? filter.start_time * 1000 : new Date()).format("MM/DD/YYYY")
                                } - ${
                                    moment(filter.end_time ? filter.end_time * 1000 : new Date()).format("MM/DD/YYYY")
                                }`}
                            />
                        </DateRangePicker>
                        <span
                            role="button"
                            className="position-absolute end-0 top-50 translate-middle-y pe-3"
                            onClick={() => setFilter((prev) => ({ ...prev, start_time: "", end_time: "" }))}
                        >
                            <i className="fas fa-times" />
                        </span>
                    </div>
                </div>
            );
        }
        if (item.type === "checkbox") {
            return (
                <div className="d-flex flex-column justify-content-center">
                    <label className="form-label">&nbsp;</label>
                    <div className="d-flex gap-3">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id={item.value}
                            name={item.value}
                            checked={!!filter[item.value]}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setFilter((prev) => ({
                                    ...prev,
                                    [item.value]: checked ? 1 : "",
                                }));
                            }}
                        />
                        <label className="form-check-label fs-6 fw-semibold text-dark" htmlFor={item.value}>
                            {item.label}
                        </label>
                    </div>
                </div>
            );
        }
        return (
            <div className="d-flex flex-column" key={item.value}>
                <label className="form-label">{item.label}</label>
                <SelectBox
                    options={(more_filters[item.value] || []).map((item) => ({
                        value: item.id,
                        label: item.name,
                    }))}
                    value={filter[item.value] || item.defaultValue || ""}
                    placeholder={`Select ${item.label}`}
                    onChange={(data) => {
                        setFilter((prev) => ({
                            ...prev,
                            [item.value]: data.value || "",
                        }));
                    }}
                />
            </div>
        );
    };

    return (
        <div className="d-flex flex-column gap-3">
            {filterCategory.map((cateFilter) => (
                <div className="d-flex gap-10 mb-4">
                    <label className="form-label" style={{ minWidth: "135px", textAlign: "right" }}>
                        {cateFilter.label}
                    </label>
                    <SpyFilterCategory
                        value={filter?.[cateFilter.key]}
                        onChange={(value) =>
                            setFilter((prev) => ({
                                ...filter,
                                [cateFilter.key]:
                                    JSON.stringify(prev?.[cateFilter.key]) === JSON.stringify(value) ? "" : value,
                            }))
                        }
                        filterCategory={cateFilter.data || []}
                    />
                </div>
            ))}
            {Boolean(filterShows.length) && (
                <div className="d-flex gap-10 mt-4">
                    <label className="form-label" style={{ minWidth: "130px", textAlign: "right" }}>
                        Filters
                    </label>
                    <div className="d-flex gap-4 flex-wrap">{filterShows.map((item) => DrawFilter(item))}</div>
                </div>
            )}
            {Boolean(filterAdvancedShows.length) && (
                <div className="d-flex gap-10 mt-4">
                    <label className="form-label" style={{ minWidth: "130px", textAlign: "right" }}>
                        Advanced
                    </label>
                    <div className="d-flex gap-4 flex-wrap">{filterAdvancedShows.map((item) => DrawFilter(item))}</div>
                </div>
            )}
        </div>
    );
};

export default SpyFilter;
